import React from 'react';
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

import * as homeImageStyles from './homeImage.module.scss'

const HomeImage = () => {
    const data = useStaticQuery(graphql`
        query {
            contentfulImages (name: {eq: "Main Home Image"}) {
                image {
                    imgixImage {
                        gatsbyImageData (layout: FULL_WIDTH, imgixParams: {q: 75})
                      }
                    title
                }
            }
        }
    `)

    return (
        <div className={homeImageStyles.imageBox}>
            <GatsbyImage
                image={data.contentfulImages.image.imgixImage.gatsbyImageData}
                alt={data.contentfulImages.image.title}
                loading="eager" />
            {/* <h1 className={homeImageStyles.textOverlay}>Welcome, explorer</h1> */}
        </div>
    );
}

export default HomeImage